import { FaultCodeTypeIndicator } from '../../../entities/disable-fault-codes-v1/fault-code-type-indicator';
import { Fmi } from '../../../entities/disable-fault-codes-v1/fmi';
import { QueueDisableFaultCodeRequest } from '../../../entities/disable-fault-codes-v1/queue-disable-fault-code-request';
import { RemoveDisableFaultCodeRequest } from '../../../entities/disable-fault-codes-v1/remove-disable-fault-code-request';
import { Wci } from '../../../entities/disable-fault-codes-v1/wci';
import { FaultCode } from '../../../entities/global-search-v2/fault-code';
import DisableFaultCodes from '../../../services/disable-fault-codes-v1';
import { GetDisabledFaultCodeRequest } from '../../../services/types';
import { LoginState } from '../../../store/login/types';
import { Result } from '../../../store/search/types';

export interface FullFaultCodeRequest {
  ecuId: string;
  faultCodeTypeIndicator: FaultCodeTypeIndicator | string;
  code: FaultCode | string;
  fmi: Fmi | string;
  wci: Wci | string;
}

export const getFaultCodesConfigurationStatuses = async ({
  login,
  selectedEntity,
}: {
  login: LoginState;
  selectedEntity: Result;
}) => {
  const {
    client,
    envVariables: { disableFaultCode },
  } = login;

  const configStatuses = new DisableFaultCodes(client, disableFaultCode);
  const { deviceKey } = selectedEntity;
  if (deviceKey) {
    const deviceInput: GetDisabledFaultCodeRequest = {
      deviceKey,
    };
    const response = await configStatuses.configStatuses(deviceInput);
    return response.data.configs;
  }
  return null;
};

export const queueFaultCodeConfigurations = async ({
  login,
  selectedEntity,
  faultCodeConfigs,
  snackbarCallback,
}: {
  login: LoginState;
  selectedEntity: Result;
  faultCodeConfigs: any;
  snackbarCallback: Function;
}) => {
  const {
    client,
    envVariables: { disableFaultCode },
  } = login;
  const clientAuth: any = client?.authenticate();
  const userId = clientAuth.loginId;
  const { ecuId, faultCodeTypeIndicator, code, fmi, wci } = faultCodeConfigs;
  const queuePayload: QueueDisableFaultCodeRequest = {
    configs: [
      {
        telematicsAssetId: selectedEntity.telematicsAssetId,
        disableFaultCodes: [
          {
            ecuId,
            disableFaultCodeConfigs: [
              {
                faultCodeTypeIndicator,
                code,
                fmi,
                wci,
              },
            ],
          },
        ],
      },
    ],
    wakeup: true,
    reboot: true,
    userId,
    applicationId: 'iot-gateway',
  };
  try {
    const configStatuses = new DisableFaultCodes(client, disableFaultCode);
    const response = await configStatuses.queueConfigs(queuePayload);
    snackbarCallback({ message: 'Successfully added', variant: 'success' });
    return response.data;
  } catch {
    snackbarCallback({ message: 'There was a problem adding fault code', variant: 'error' });
    return null;
  }
};

export const removeFaultCodeConfigurations = async ({
  login,
  selectedEntity,
  snackbarCallback,
}: {
  login: LoginState;
  selectedEntity: Result;
  snackbarCallback: Function;
}) => {
  const {
    client,
    envVariables: { disableFaultCode },
  } = login;
  const clientAuth: any = client?.authenticate();
  const userId = clientAuth.loginId;
  const queuePayload: RemoveDisableFaultCodeRequest = {
    configs: [
      {
        telematicsAssetId: selectedEntity.telematicsAssetId,
      },
    ],
    wakeup: true,
    reboot: true,
    userId,
    applicationId: 'iot-gateway',
  };
  try {
    const configStatuses = new DisableFaultCodes(client, disableFaultCode);
    const response = await configStatuses.removeConfigs(queuePayload);
    snackbarCallback({ message: 'Successfully requested removal', variant: 'success' });
    return response.data;
  } catch {
    snackbarCallback({ message: 'There was a problem requesting removal', variant: 'error' });
    return null;
  }
};
